function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Defs, Rect, G, Mask, Use, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Rect, {
  id: "icon-view-camera_svg__a",
  width: 61,
  height: 61,
  x: 0,
  y: 0,
  rx: 10
}));

var _ref2 = /*#__PURE__*/React.createElement(G, {
  transform: "translate(.338)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Mask, {
  id: "icon-view-camera_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#icon-view-camera_svg__a"
})), /*#__PURE__*/React.createElement(Use, {
  fill: "#00245A",
  xlinkHref: "#icon-view-camera_svg__a"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#17BF88",
  strokeWidth: 1.5,
  mask: "url(#icon-view-camera_svg__b)"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M34.85 24.576A4.575 4.575 0 0030.274 20a4.575 4.575 0 00-4.576 4.576 4.575 4.575 0 004.576 4.576 4.575 4.575 0 004.576-4.576z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M38.885 37.763a8.61 8.61 0 10-17.222 0"
})));

function SvgIconViewCamera(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 61
  }, props), _ref, _ref2);
}

export default SvgIconViewCamera;